import React from 'react';

import styles from './BudgetDifference.module.css';
import RDSHeading from '../../components/RDSHeading';
import { formatCents } from '../../utils';
import classNames from 'classnames';

type BudgetDifferenceProps = {
  difference: number;
};
const BudgetDifference = (props: BudgetDifferenceProps) => {
  const { difference } = props;
  return (
    <div className={styles.BudgetDifference}>
      <RDSHeading level={'2'} size="xsmall" className={styles.Heading}>
        Difference
      </RDSHeading>
      <div
        className={classNames(styles.Value, {
          [styles.IsNegative]: difference < 0,
          [styles.IsPositive]: difference > 0,
        })}
        data-testid="budget_difference"
      >
        {formatCents(difference, { currency: '$', showPositiveSign: true })}
      </div>
    </div>
  );
};
export default BudgetDifference;
